import * as fields from '@Forms/validation/fields';

import type { CountryCode } from '@Types/Base';

interface Params {
  lang: string;
  country: CountryCode;
}

export default ({ country, lang }: Params) => {
  return {
    title: 'JSON schema',
    $schema: 'http://json-schema.org/draft-07/schema',
    type: 'object',
    properties: {
      name: fields.firstName(lang, { minLength: 1 }),
      phone: fields.phone({ country, lang }),
      email: {
        anyOf: [fields.email(lang), { type: 'string', enum: [''] }],
      },
      photo: {
        type: 'object',
        contentEncoding: 'base64',
        contentMediaType: '.jpg, .png, .pdf',
        errorMessage: {
          contentMediaType: 'Загрузить можно только фото в форматах jpg, png, pdf',
        },
      },
    },
    required: ['name', 'phone'],
  };
};
